import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=46cab352&scoped=true&"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./MenuPrincipal.vue?vue&type=style&index=0&id=46cab352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cab352",
  null
  
)

export default component.exports